import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getCFMUpdateData } from '../state';
import {
  isAlertVisibleSelector,
  isModalOpenSelector,
} from '../state/selectors';
import { CFMStepModal } from './CFMStepModal';
import CFMAlert from './CFMAlert';

export default function CFMUpdate() {
  const dispatch = useDispatch();

  const isModalOpen = useSelector(isModalOpenSelector);
  const isAlertVisible = useSelector(isAlertVisibleSelector);

  useEffect(() => {
    dispatch(getCFMUpdateData());
  }, [dispatch]);

  return (
    <>
      {isAlertVisible && <CFMAlert />}
      {isModalOpen && <CFMStepModal />}
    </>
  );
}
